import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import {Box, Typography} from '@customink/pigment-react';
import PropTypes from 'prop-types';
import React from 'react';

export default function ProductCardDiscountedPrice({
  discountedPrice,
  originalPrice,
  quantity
}) {
  return (
    <Typography
      fontSize="0.8125rem"
      lineHeight={1.25}
      data-testid="product-price-container">
      <Typography
        component="span"
        fontSize="0.8125rem"
        lineHeight={1.25}
        sx={{
          color: designTokens.color.gray.slateDefault.value,
          textDecoration: 'line-through'
        }}
        data-testid="product-price-value">
        {originalPrice}
      </Typography>
      <Box
        component="span"
        fontWeight={700}
        sx={{
          color: designTokens.color.red.default.value,
          marginLeft: '0.25rem'
        }}
        data-testid="product-discounted-price-value">
        {discountedPrice}
      </Box>
      <Box component="span">/ea for {quantity} items</Box>
    </Typography>
  );
}

ProductCardDiscountedPrice.propTypes = {
  discountedPrice: PropTypes.string.isRequired,
  originalPrice: PropTypes.string.isRequired,
  quantity: PropTypes.number.isRequired
};
